import { HttpClient } from '#client/http/index'
import {
  ActivityWithProgramCount,
  ActivityId,
  ActivityDetail,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<ActivityWithProgramCount[]> =
    await httpClient.get('/user/activities')
  return data
}

export const get = async (
  { httpClient }: { httpClient: HttpClient },
  id: ActivityId,
) => {
  const data: ActivityDetail = await httpClient.get(`/user/activities/${id}`)
  return data
}
